import { Message } from 'element-ui'
// 公用消息提示
export default function ({ title = '提示', message, type = 'success', duration = 2000, showClose = true, onClose }) {
  return Message({
    title,
    type,
    message,
    duration: duration ? duration : (type === 'error' ? 3500 : 3000),
    showClose: showClose,
    onClose
  })
};



// WEBPACK FOOTER //
// ./src/utils/message.js